// src/components/dashboard/LockedOverlay.tsx
// ✅ VERSÃO CORRIGIDA - Badge aparece no hover

import React from 'react';
import { ShoppingBag } from 'lucide-react';
import './LockedOverlay.css';

interface LockedOverlayProps {
    onUpgradeClick: (e?: React.MouseEvent) => void;
    entityType: 'cycle' | 'deck';
}

const LockedOverlay: React.FC<LockedOverlayProps> = ({
    onUpgradeClick,
    entityType
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // ✅ Evitar que clique propague para o card
        onUpgradeClick(e);
    };

    return (
        <div className="graia-locked-overlay">
            <div
                className="graia-locked-badge"
                onClick={handleClick}
            >
                <ShoppingBag size={18} />
                <span>
                    {entityType === 'cycle' ? 'Adquirir Campo' : 'Adquirir Deck'}
                </span>
            </div>
        </div>
    );
};

export default LockedOverlay;